import RotatingSound from './components/RotatingSound';

function App() {
  return <RotatingSound />;
}

export default App;